import { render } from "./BlockHoleEcology.vue?vue&type=template&id=d5a52b1e&scoped=true"
const script = {}

import "./BlockHoleEcology.vue?vue&type=style&index=0&id=d5a52b1e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a52b1e"]])

export default __exports__